import React from 'react';
import { Card, Typography, Breadcrumb, List } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Title } = Typography;

const WorkReports: React.FC = () => {
  const { isDemoBrowseOnly } = useAuth();
  return (
    <div className="page-container full-height">
      {/* 面包屑导航 */}
      <Breadcrumb
        style={{ marginBottom: '16px' }}
        items={[
          { title: (<><HomeOutlined /><span>首页</span></>) },
          { title: '工作台' },
          { title: '工作汇报' },
        ]}
      />

      <div className="page-header">
        <h1 className="page-title">工作汇报</h1>
        <p className="page-subtitle">管理工作汇报和进度跟踪</p>
      </div>

      <div className="content-area">
        <Card>
          <Title level={4}>工作汇报功能</Title>
          <p>此功能正在开发中，敬请期待...</p>
          {isDemoBrowseOnly ? (
            <>
              <Title level={5} style={{ marginTop: 24 }}>
                演示：近期汇报示例
              </Title>
              <List
                size="small"
                bordered
                dataSource={[
                  { t: '第 14 周', c: '流式上机数据已整理，下周补Western验证。' },
                  { t: '第 13 周', c: '完成试剂库存盘点，低库存品种已提交采购申请。' }
                ]}
                renderItem={(item) => (
                  <List.Item>
                    <Typography.Text strong>{item.t}</Typography.Text> — {item.c}
                  </List.Item>
                )}
              />
            </>
          ) : null}
        </Card>
      </div>
    </div>
  );
};

export default WorkReports;
